import {
  Button,
  Divider,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Grid,
  IconButton,
  InputBase,
  InputLabel,
  makeStyles,
  NativeSelect,
  Paper,
  RadioGroup,
  Select,
  TextField,
  withStyles,
  Radio,
  Slider,
  Card,
  Typography,
  CircularProgress,
  Box,
} from "@material-ui/core";
import {
  ArrowBackRounded,
  ArrowDropDown,
  ArrowForwardSharp,
  Close,
  PersonAddDisabled,
  Search,
} from "@material-ui/icons";
import React, { useEffect, useMemo, useState } from "react";
import HomeHeaderMenu from "../../Home/HomeHeaderMenu";
import SearchResult from "./Shared/SearchResult";
import { useHistory } from "react-router";
import FooterCoachSearch from "./Shared/FooterCoachSearch";
import CoachService from "./coach_service";
import AdminPartnerClient from "../../../Service/Admin/partner_services";
import CustomMultiSelectCoach from "./Shared/CustomMultiSelectCoach";
import { ObjectToFormdata } from "../../../Common/Utils/common_utils";
import { showSnackbar } from "../../../Components/Snackbar/SnackbarActions";
import { useDispatch, useSelector } from "react-redux";
import CustomInput from "../../../Components/CustomInput";
import { mappedKeyJSON } from "../StepperComponent/MappedKeyJSON";
import CustomSelectMulti from "../../../Components/CustomSelectMulti";
import CustomSelect from "../../../Components/CustomSelect";
import Autocomplete from "@material-ui/lab/Autocomplete";
import useDebounce from "../../../Components/debounce";
import DataService from "../../../Service";

function CoachSearch() {
  const history = useHistory();
  const classes = useStyles();
  const dispatch = useDispatch();

  const data: any = [
    {
      label: "",
      obj: [
        {
          name: "Full name",
          matchKey: mappedKeyJSON.FullName,
          values: [],
        },
        {
          name: "Coaching areas of expertise",
          matchKey: mappedKeyJSON.CoachingAreasOfExpertise,
          values: [],
        },
        {
          name: "Country",
          matchKey: mappedKeyJSON.BusinessCountry,
          values: [],
        },
        {
          name: "City",
          matchKey: mappedKeyJSON.City,
          values: [],
        },
        // {
        //   name: "Business city",
        //   matchKey: mappedKeyJSON.BusinessCity,
        //   values: [],
        // },
        {
          name: "Languages",
          matchKey: mappedKeyJSON.Language,
          values: [],
        },
        {
          name: "Client specific areas of expertise",
          matchKey: mappedKeyJSON.CoachingSpecificAreasOfExpertise,
          values: [],
        },
        {
          name: "Psychometric and diagnostic tools",
          matchKey: mappedKeyJSON.DiagnosticTools,
          values: [],
        },
        {
          name: "Facilitation areas of expertise",
          matchKey: mappedKeyJSON.FacilitationAreasOfExpertise,
          values: [],
        },
        {
          name: "Industry sectors worked in",
          matchKey: mappedKeyJSON.SectorExperience,
          values: [],
        },

        {
          name: "Industry sectors delivered coaching in",
          matchKey: mappedKeyJSON.IndustrySector,
          values: [],
        },
        // {
        //   name: "Client specific levels available for",
        //   matchKey: mappedKeyJSON.ClientLevelsAvailiable,
        //   values: [],
        // },
        {
          name: "Most senior role held",
          matchKey: mappedKeyJSON.MostSeniorRoleHeld,
          values: [],
        },
        {
          name: "Levels coached at",
          matchKey: mappedKeyJSON.Level,
          values: [],
        },
        {
          name: "Disciplines worked in",
          matchKey: mappedKeyJSON.Discipline,
          values: [],
        },
        {
          name: "Business post code",
          matchKey: mappedKeyJSON.BusinessPostCode,
          values: [],
        },
        {
          name: "Location/Radius",
          matchKey: mappedKeyJSON.LocationRadius,
          values: [],
        },
      ],
    },
  ];

  // var data: any = [
  //   {
  //     label: "",
  //     obj: [
  //       {
  //         name: "Currently available for new assignments",
  //         matchKey: mappedKeyJSON.CurrentlyAvailableForAssignment,
  //         values: [],
  //       },
  //       {
  //         name: "Coaching areas of expertise",
  //         matchKey: mappedKeyJSON.CoachingAreasOfExpertise,
  //         values: [],
  //       },
  //       {
  //         name: "Client specific areas of expertise",
  //         matchKey: mappedKeyJSON.CoachingSpecificAreasOfExpertise,
  //         values: [],
  //       },
  //       {
  //         name: "Levels coached at",
  //         matchKey: mappedKeyJSON.Level,
  //         values: [],
  //       },
  //       {
  //         name: "Disciplines worked in",
  //         matchKey: mappedKeyJSON.Discipline,
  //         values: [],
  //       },
  // {
  //   name: "City",
  //   matchKey: mappedKeyJSON.City,
  //   values: [],
  // },
  // {
  //     name: "Client specific levels available for",
  //     matchKey: mappedKeyJSON.ClientLevelsAvailiable,
  //     values: []
  // },
  //     {
  //       name: "Industry sectors worked in",
  //       matchKey: mappedKeyJSON.SectorExperience,
  //       values: [],
  //     },

  //     {
  //       name: "Industry sectors delivered coaching in",
  //       matchKey: mappedKeyJSON.IndustrySector,
  //       values: [],
  //     },
  //     {
  //       name: "Psychometric and diagnostic tools",
  //       matchKey: mappedKeyJSON.DiagnosticTools,
  //       values: [],
  //     },
  //     {
  //       name: "Business city",
  //       matchKey: mappedKeyJSON.BusinessCity,
  //       values: [],
  //     },
  //   ],
  // },
  // {
  //   label: "Background/corporate",
  //   obj: [
  //     {
  //       name: "Most senior role held",
  //       matchKey: mappedKeyJSON.MostSeniorRoleHeld,
  //       values: [],
  //     },
  //     {
  //       name: "Levels coached at",
  //       matchKey: mappedKeyJSON.Level,
  //       values: [],
  //     },
  //     {
  //         name: "Department",
  //         matchKey: mappedKeyJSON.InternalJobTitle,
  //         values: []
  //     },
  //     {
  //       name: "Worked in the public sector",
  //       matchKey: mappedKeyJSON.WorkedInPublicSector,
  //       values: [],
  //     },
  //     {
  //       name: "Worked in the private sector",
  //       matchKey: mappedKeyJSON.WorkedInPrivateSector,
  //       values: [],
  //     },
  //     {
  //       name: "Business country",
  //       matchKey: mappedKeyJSON.BusinessCountry,
  //       values: [],
  //     },
  //     {
  //       name: "Languages",
  //       matchKey: mappedKeyJSON.Language,
  //       values: [],
  //     },
  //   ],
  // },
  // {
  //   label: "Experience",
  //   obj: [
  //     {
  //       name: "Facilitation areas of expertise",
  //       matchKey: mappedKeyJSON.FacilitationAreasOfExpertise,
  //       values: [],
  //     },
  //   ],
  // },
  // {
  //   label: "Name",
  //   obj: [
  //     {
  //       name: "First Name",
  //       matchKey: mappedKeyJSON.FirstName,
  //       values: [],
  //     },
  //     {
  //       name: "Middle Name",
  //       matchKey: mappedKeyJSON.MiddleName,
  //       values: [],
  //     },
  //     {
  //       name: "Last Name",
  //       matchKey: mappedKeyJSON.LastName,
  //       values: [],
  //     },
  //     {
  //       name: "Full name",
  //       matchKey: mappedKeyJSON.FullName,
  //       values: [],
  //     },
  //   ],
  // },
  // {
  //   label: "Admin ",
  //   obj: [
  //     {
  //       name: "Type of partner",
  //       matchKey: mappedKeyJSON.TypeOfPartner,
  //       values: [],
  //     },
  //     {
  //       name: "Candidate status",
  //       matchKey: mappedKeyJSON.Label,
  //       values: [],
  //     },
  //   ],
  // },
  // {
  //   label: "Location",
  //   obj: [
  //     {
  //       name: "Business county",
  //       matchKey: mappedKeyJSON.BusinessCounty,
  //       values: [],
  //     },
  //     {
  //       name: "Business post code",
  //       matchKey: mappedKeyJSON.BusinessPostCode,
  //       values: [],
  //     },
  // {
  //   name: "Business zip code",
  //   matchKey: mappedKeyJSON.BusinessZipCode,
  //   values: [],
  // },
  //       {
  //         name: "Location/Radius",
  //         matchKey: mappedKeyJSON.LocationRadius,
  //         values: [],
  //       },
  //       {
  //         name: "Country",
  //         matchKey: mappedKeyJSON.BusinessCountry,
  //         values: [],
  //       },
  //     ],
  //   },
  // ];
  const [state, setState] = React.useState({ age: "", name: "hai" });
  const [updatedData, setupdatedData] = useState([]);
  const [dynamicDropdownValue, setDynamicDropdownValue] = useState([]);
  const [additionalFilter, setAdditionalFilter] = useState(false);
  const [selectedFilter, setSelectedFilter] = useState<any>({});
  const [searchResultArr, setSearchResultArr] = useState([]);
  const [selectedSendData, setSelectedSendData] = useState<any>([]);
  const [value, setValue] = React.useState("female");
  const [locationDropdownFlag, setLocationDropdownFlag] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [partnerRolesArr, setPartnerRolesArr]: any = useState([]);
  const [partnerDummyRoleArr, setPartnerDummyRoleArr]: any = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [searchId, setSearchId] = useState(0);

  useEffect(() => {
    getListingDropdowns();
    getSearchId();
  }, []);

  const getListingDropdowns = () => {
    AdminPartnerClient.dropdown_get("CombineListingDropDown").then(
      (response: any) => {
        partnerDummyRoleArr.length = 0;
        var pdata = [
          ...response[mappedKeyJSON.Role],
          { id: response[mappedKeyJSON.Role] + 1, value: "Add New" },
        ];
        setPartnerDummyRoleArr(partnerDummyRoleArr.concat(pdata));

        data.map((option: any) => {
          option.obj.map((e: any) => {
            var localArr: any = [];
            response[e.matchKey].map((option: any) => {
              var pdata = {
                title: option.value == null ? "" : option.value,
                id: option.id,
              };
              localArr.push(pdata);
            });
            e.values = localArr;
          });
        });
        dynamicDropdownValue.length = 0;
        setDynamicDropdownValue(dynamicDropdownValue.concat(data[0]));
        setupdatedData(updatedData.concat(data));
      }
    );
  };

  const handleChange = (event: any, newValue: any) => {
    // setUserData({ ...userData, location_radius: newValue });
    setSelectedFilter({ ...selectedFilter, location_radius: newValue });
  };
  const handleInputChange = (
    inputStateValue: any,
    inputId: any,
    index: any
  ) => {
    setSelectedFilter({ ...selectedFilter, [inputId]: inputStateValue });
  };

  const onChangeMultipleItem = (inputStateValue: any, inputId: any) => {
    var pdata: any = selectedFilter;

    if (inputStateValue.length > 0) {
      pdata[inputId.matchKey] = {
        name: inputId.name,
        selectedValue: inputStateValue
          .map((option: any) => option.title)
          .join(","),
        selectedValueId: inputStateValue.map((option: any) => option.id),
        defaultValue: inputStateValue,
      };
      setSelectedFilter({ ...selectedFilter, ...pdata });
    } else {
      removeFilterData(inputId.matchKey);
    }
  };

  const onChangeItem = (selectedItemValue: any, inputId: any) => {
    if (selectedItemValue.id == "currently_available_for_assignment") {
      selectedItemValue.value =
        selectedItemValue.value == "Yes" ? "true" : "false";
    }
    setSelectedSendData({
      ...selectedSendData,
      [selectedItemValue.id]: selectedItemValue.value,
    });
  };

  const onChangeMultiItem = (obj: any, inputId: any, routeFrom: any) => {
    console.log(obj, inputId, routeFrom);

    if (inputId == "partnerRolesArr") {
      partnerRolesArr.length = 0;
      setPartnerRolesArr(partnerRolesArr.concat(obj));
    }
  };

  const removeFilterData = (e: any) => {
    var pdata: any = {};
    for (const key in selectedFilter) {
      if (Object.prototype.hasOwnProperty.call(selectedFilter, key)) {
        const element = selectedFilter[key];
        e !== key && (pdata[key] = element);
      }
    }
    console.log(pdata);
    setSelectedFilter(pdata);
    setSelectedSendData(pdata);
  };

  const filterData = useMemo(() => {
    const specificFilter = Object.fromEntries(
      Object.entries(selectedFilter).filter(([key]) =>
        key.includes("location_radius")
      )
    );
    const specificFilter1 = Object.fromEntries(
      Object.entries(selectedFilter).filter(([key]) =>
        key.includes("business_postcode")
      )
    );
    const filterVal = Object.values(specificFilter).toString();
    return Object.keys(selectedFilter).map((key) => {
      return (
        <React.Fragment>
          {key === "business_postcode" && (
            <div className={classes.categoryBox}>
              <label className={classes.categoryTitle}>
                Business post/zip code:
              </label>
              <label className={classes.categoryDetail}>
                {selectedFilter[key]}
              </label>
              <Close
                onClick={() => {
                  removeFilterData(key);
                }}
                className={classes.categoryicon}
              />
            </div>
          )}

          {key === "location_radius" ? (
            <div className={classes.categoryBox}>
              <label className={classes.categoryTitle}>Location/Radius:</label>
              <label className={classes.categoryDetail}>
                {selectedFilter[key]}
              </label>
              <Close
                onClick={() => {
                  removeFilterData(key);
                }}
                className={classes.categoryicon}
              />
            </div>
          ) : (
            key !== "business_postcode" && (
              <div className={classes.categoryBox}>
                <label className={classes.categoryTitle}>
                  {selectedFilter[key]["name"]}:
                </label>
                <label className={classes.categoryDetail}>
                  {selectedFilter[key]["selectedValue"]}
                </label>
                <Close
                  onClick={() => {
                    removeFilterData(key);
                  }}
                  className={classes.categoryicon}
                />
              </div>
            )
          )}
        </React.Fragment>
      );
    });
  }, [selectedFilter, selectedSendData]);

  const PrettoSlider = withStyles({
    root: {
      color: "#981B1E",
      height: 5,
      marginTop: 35,
    },
    thumb: {
      height: 15,
      width: 15,
      backgroundColor: "#fff",
      border: "2px solid currentColor",
      marginTop: -5,
      marginLeft: -12,
      "&:focus, &:hover, &$active": {
        boxShadow: "inherit",
      },
    },

    active: {},
    valueLabel: {
      left: "calc(-50% + 4px)",
      fontSize: "9px",
    },
    track: {
      height: 5,
      borderRadius: 4,
    },
    rail: {
      height: 5,
      borderRadius: 4,
    },
  })(Slider);

  const getSearchId = () => {
    DataService.getDirectData("searches/find_search?search_type=Combine", {})
      .then((response: any) => {
        setSearchId(response.search_id);
      })
      .catch((error) =>
        dispatch(showSnackbar("error", ["Some error occured!"]))
      )
      .finally(() => setIsLoading(false));
  };

  const searchLogic = () => {
    var pdata: any = {};
    for (const key in selectedFilter) {
      if (key === "location_radius") {
        let temp: any = String(selectedFilter[key]);
        let finalValue = temp.split();
        pdata[key] = finalValue;
      } else if (key === "business_postcode") {
        let temp: any = String(selectedFilter[key]);
        let finalValue = temp.split();
        pdata[key] = finalValue;
      } else if (key === "department_list_id") {
        pdata["magic20_associate_id"] = selectedFilter[key]["selectedValueId"]
          .toString()
          .split(",");
      } else pdata[key] = selectedFilter[key]["selectedValueId"];
    }

    var localRoleArr: any = [];
    partnerRolesArr.map((option: any) => localRoleArr.push(option.id));

    setIsLoading(true);
    CoachService.coachCombineSearch(
      ObjectToFormdata({
        role_id: JSON.stringify(localRoleArr),
        search_term: searchQuery,
        search_query: " ",
        search_attributes: JSON.stringify(pdata),
        search_type: "Combine",
        type: sessionStorage.getItem("role"),
        search_id: searchId,
      })
    )
      .then((response: any) => {
        searchResultArr.length = 0;
        if (response.errors) {
          setSearchResultArr([]);
          dispatch(showSnackbar("error", ["" + response.errors]));
        } else {
          setSearchQuery("");
          setSearchResultArr(searchResultArr.concat(response.data));
        }
      })
      .catch((error) => {
        searchResultArr.length = 0;
        setSearchResultArr([]);
        dispatch(showSnackbar("error", ["Some error occured!"]));
      })
      .finally(() => setIsLoading(false));
  };

  const setResetFilter = () => {
    setAdditionalFilter(!additionalFilter);
    if (additionalFilter) {
      dynamicDropdownValue.length = 0;
      setDynamicDropdownValue(dynamicDropdownValue.concat(updatedData[0]));
    } else {
      dynamicDropdownValue.length = 0;
      setDynamicDropdownValue(dynamicDropdownValue.concat(updatedData));
    }
  };

  const clearAllFilterHandler = () => {
    setSelectedFilter({});

    // // @ts-ignore
    // setDynamicDropdownValue((prevState: any) => {
    //   const updatedState = [...prevState];

    //   updatedState.map((option: any) => {
    //     return option.obj.map((item: any) => {
    //       return (item["values"] = []);
    //     });
    //   });
    //   console.log("updatedState", updatedState);
    //   return updatedState;
    // });

    // dynamicDropdownValue.map((option: any) => {
    //   console.log(option?.obj);
    // });
  };
  return (
    <>
      <Grid container direction="row" alignItems="center" justify="center">
        <Grid item xs={12}>
          <HomeHeaderMenu />
        </Grid>
      </Grid>
      <Grid
        container
        direction="row"
        alignItems="center"
        justify="center"
        style={{ backgroundColor: "#B4B4B440" }}
      >
        <Grid
          item
          xs={12}
          style={{ padding: "20px 0", margin: "25px", backgroundColor: "#fff" }}
        >
          <Grid container direction="row" justify="center" alignItems="center">
            <Grid item xs={8} style={{ marginBottom: 10 }}>
              <ArrowBackRounded
                onClick={() => {
                  history.goBack();
                }}
              />
              <Typography
                component="span"
                variant="subtitle1"
                style={{
                  verticalAlign: "super",
                  fontWeight: "bold",
                  paddingLeft: 10,
                }}
              >
                Search coach
              </Typography>
            </Grid>
          </Grid>
          <Grid container direction="row" justify="center" alignItems="center">
            <Grid
              item
              xs={8}
              alignItems="center"
              className={classes.bgContainer}
            >
              <Grid
                container
                direction="row"
                alignItems="flex-start"
                justifyContent="center"
                style={{ marginBottom: 20 }}
              >
                <Grid item xs={7}>
                  <Paper component="form" className={classes.root}>
                    <Box style={{ display: "flex", alignItems: "center" }}>
                      <Box style={{ display: "grid", alignItems: "center" }}>
                        <IconButton
                          type="submit"
                          className={classes.iconButton}
                          aria-label="search"
                        >
                          <Search />
                        </IconButton>
                      </Box>

                      <InputBase
                        className={classes.input}
                        placeholder="Search coach"
                        onChange={(e: any) => {
                          setSearchQuery(e.target.value);
                        }}
                        inputProps={{ "aria-label": "search" }}
                      />
                    </Box>
                  </Paper>
                </Grid>

                <Grid item xs={5}>
                  <Grid
                    container
                    direction="row"
                    alignItems="flex-start"
                    style={{ marginLeft: 20 }}
                  >
                    <Grid item xs={4}>
                      <Button
                        variant="contained"
                        color="secondary"
                        className={classes.btnSearch}
                        onClick={() => {
                          searchLogic();
                        }}
                      >
                        Search
                      </Button>
                    </Grid>
                    <Grid item xs={6}>
                      {/* <Button
                        onClick={setResetFilter}
                        variant="contained"
                        color="secondary"
                        className={classes.btnAdditional}
                      >
                        {additionalFilter ? "Hide" : "Show"} additional filters
                      </Button> */}
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              {Object.keys(selectedFilter).length > 0 && (
                <Grid
                  container
                  direction="row"
                  alignItems="flex-start"
                  style={{ marginBottom: 20 }}
                >
                  <Grid item xs={12}>
                    <Paper className={classes.root} style={{ border: 0 }}>
                      <Grid container direction="row">
                        <Grid item xs={10}>
                          {filterData}
                        </Grid>
                        <Grid item xs={2}>
                          <label
                            style={{
                              color: "#077F83",
                              fontSize: 12,
                              paddingLeft: 10,
                              textDecoration: "underline",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              clearAllFilterHandler();
                            }}
                          >
                            Clear all filters
                          </label>
                        </Grid>
                      </Grid>
                    </Paper>
                  </Grid>
                </Grid>
              )}

              {dynamicDropdownValue.length > 0 &&
                dynamicDropdownValue.map((option: any) => {
                  return (
                    <Grid
                      container
                      direction="row"
                      alignItems="center"
                      style={{ marginTop: 30 }}
                    >
                      <Grid item xs={12} style={{ marginBottom: 10 }}>
                        <Typography
                          variant="h2"
                          className={classes.headingTitle}
                        >
                          {option.label}
                        </Typography>
                      </Grid>
                      <Grid item xs={12}>
                        <Grid
                          container
                          direction="row"
                          alignItems="flex-start"
                          style={{ marginTop: "10" }}
                        >
                          {option.obj.map((e: any) => {
                            return (
                              <>
                                {e.name === "Business post code" && (
                                  <Grid
                                    item
                                    xs={3}
                                    style={{
                                      paddingLeft: "10px",
                                      paddingRight: "10px",
                                    }}
                                  >
                                    {/* <CustomMultiSelectCoach
                                  limitTags={1}
                                  id={e.matchKey}
                                  values={e}
                                  defaultValue={
                                    selectedFilter[e.matchKey]
                                      ?.defaultValue == undefined
                                      ? []
                                      : selectedFilter[e.matchKey]
                                          ?.defaultValue
                                  }
                                  parentcall={onChangeMultipleItem}
                                /> */}
                                    <CustomInput
                                      placeholder="Business post/zip code"
                                      className={classes.textField}
                                      style={{
                                        marginBlock: 12,
                                        backgroundColor: "white",
                                      }}
                                      id={e.matchKey}
                                      inputProps={{
                                        style: {
                                          height: "27px",
                                        },
                                      }}
                                      variant="outlined"
                                      parentcall={handleInputChange}
                                    />
                                  </Grid>
                                )}
                                {e.name !== "Location/Radius" &&
                                e.name !== "Business post code" ? (
                                  <Grid
                                    item
                                    xs={3}
                                    style={{
                                      paddingLeft: "10px",
                                      paddingRight: "10px",
                                    }}
                                  >
                                    <CustomMultiSelectCoach
                                      limitTags={1}
                                      id={e.matchKey}
                                      values={e}
                                      defaultValue={
                                        selectedFilter[e.matchKey]
                                          ?.defaultValue == undefined
                                          ? []
                                          : selectedFilter[e.matchKey]
                                              ?.defaultValue
                                      }
                                      parentcall={onChangeMultipleItem}
                                    />
                                  </Grid>
                                ) : (
                                  e.name !== "Business post code" && (
                                    <Grid item xs={3}>
                                      <Card
                                        variant="outlined"
                                        style={{ padding: 10, margin: 10 }}
                                      >
                                        <Grid
                                          container
                                          direction="row"
                                          alignItems="flex-start"
                                          style={{
                                            marginBottom:
                                              e.name === "Location/Radius"
                                                ? 0
                                                : 20,
                                          }}
                                        >
                                          <Grid item xs={12}>
                                            <div
                                              onClick={() => {
                                                setLocationDropdownFlag(
                                                  !locationDropdownFlag
                                                );
                                              }}
                                              style={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                alignItems: "center",
                                              }}
                                            >
                                              <Typography
                                                variant="h2"
                                                className={
                                                  classes.locationTitle
                                                }
                                              >
                                                Location/Radius (km)
                                              </Typography>
                                              <div style={{ float: "right" }}>
                                                <ArrowDropDown />
                                              </div>
                                            </div>
                                          </Grid>
                                          {locationDropdownFlag && (
                                            <>
                                              {/* <Grid item xs={12}>
                                              <Paper
                                                component="form"
                                                className={classes.rootPop}
                                              >
                                                <IconButton
                                                  className={
                                                    classes.iconButtonPop
                                                  }
                                                  aria-label="menu"
                                                >
                                                  <Search />
                                                </IconButton>
                                                <InputBase
                                                  className={classes.inputPop}
                                                  placeholder="Search/add new location"
                                                  inputProps={{
                                                    "aria-label": "search ",
                                                  }}
                                                />
                                              </Paper>
                                            </Grid> */}

                                              {/* <Grid
                                              item
                                              xs={12}
                                              style={{
                                                marginTop: 10,
                                                marginBottom: 10,
                                              }}
                                            >
                                              <label
                                                className={
                                                  classes.locationTitle2
                                                }
                                              >
                                                Location in CRF
                                              </label>
                                            </Grid> */}
                                              {/* <Grid item xs={12}>
                                              <FormControl component="fieldset">
                                                <RadioGroup
                                                  aria-label="gender"
                                                  name="gender1"
                                                  value={value}
                                                  onChange={handleChange}
                                                >
                                                  <FormControlLabel
                                                    value="female"
                                                    control={<Radio />}
                                                    label="Location 1"
                                                    className={
                                                      classes.radioLocationTitle
                                                    }
                                                  />
                                                  <FormControlLabel
                                                    value="male"
                                                    control={<Radio />}
                                                    label="Location 2"
                                                    className={
                                                      classes.radioLocationTitle
                                                    }
                                                  />
                                                </RadioGroup>
                                              </FormControl>
                                            </Grid> */}
                                              {/* <Grid item xs={12}>
                                              <label
                                                className={
                                                  classes.locationTitle2
                                                }
                                              >
                                                Choose Radius
                                              </label>
                                            </Grid> */}
                                              <Grid item xs={12}>
                                                {/* <Slider
                                                                              defaultValue={30}
                                                                              getAriaValueText={valuetext}
                                                                              aria-labelledby="discrete-slider"
                                                                              valueLabelDisplay="auto"
                                                                              step={10}
                                                                              marks
                                                                              min={10}
                                                                              max={110}
                                                                              className={classes.sliderRadius}
                                                                          /> */}
                                                {/* <PrettoSlider
                                                valueLabelDisplay="auto"
                                                aria-label="pretto slider"
                                                defaultValue={20}
                                              /> */}
                                                <Slider
                                                  // value={userData.location_radius}
                                                  // values={e}
                                                  // defaultValue={
                                                  //   selectedFilter[e.matchKey]
                                                  //     ?.defaultValue == undefined
                                                  //     ? []
                                                  //     : selectedFilter[e.matchKey]
                                                  //         ?.defaultValue
                                                  // }
                                                  onChange={handleChange}
                                                  id={e.matchKey}
                                                  defaultValue={0}
                                                  aria-labelledby="continuous-slider"
                                                  step={10}
                                                  valueLabelDisplay="on"
                                                />
                                              </Grid>
                                            </>
                                          )}
                                        </Grid>
                                      </Card>
                                    </Grid>
                                  )
                                )}
                              </>
                            );
                          })}
                        </Grid>
                      </Grid>
                    </Grid>
                  );
                })}
            </Grid>
            <Grid item xs={8} alignItems="center" style={{ padding: 0 }}>
              {isLoading ? (
                <Box
                  width="100%"
                  display="flex"
                  justifyContent="center"
                  mt="20px"
                >
                  <CircularProgress size={30} color="primary" />
                </Box>
              ) : (
                <SearchResult
                  resultArr={searchResultArr}
                  coachType="combined"
                />
              )}
            </Grid>
            <Grid item xs={8} alignItems="center">
              <Grid container direction="row" alignItems="center">
                <Grid item xs={12} style={{ marginTop: 50 }}>
                  <FooterCoachSearch />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}

export default CoachSearch;

const useStyles = makeStyles((theme) => ({
  bgContainer: {
    backgroundColor: `${theme.palette.primary.light}`,
    padding: 20,
    position: "relative",
  },
  root: {
    padding: "5px 4px",
    // display: 'flex',
    alignItems: "center",
    // width: 400,
    border: `1px solid ${theme.palette.primary.main}`,
    boxShadow: "none",
    borderRadius: "0",
    // height: 100,
  },
  input: {
    marginLeft: "0.25rem",
    marginTop: "0.15rem",
    flex: 1,
    width: "100%",
  },
  iconButton: {
    height: "2rem",
    width: "2rem",
    padding: 0,
    color: `${theme.palette.primary.main}`,
    // marginTop: 10,
  },
  categoryBox: {
    border: "1px solid #077F83",
    padding: 2,
    marginTop: 2,
    marginBottom: 2,
    marginRight: 5,
    marginLeft: 5,
    borderRadius: 2,
    display: "-webkit-inline-box",
  },
  categoryTitle: {
    color: "#077F83",
    fontSize: 14,
    padding: 5,
  },
  categoryDetail: {
    color: "#232323",
    fontSize: 14,
    paddingRight: 5,
  },
  categoryicon: {
    fontSize: 12,
    color: "#077F83",
  },
  btnSearch: {
    //  backgroundColor: "#981b1e",
    borderRadius: "0",
    textTransform: "none",
    width: "100%",
    fontSize: "14px",
    boxShadow: "none",
    "&:hover": {
      backgroundColor: "none",
    },
  },
  btnAdditional: {
    // backgroundColor: `${theme.palette.secondary.main}`,
    color: "#fff",
    borderRadius: 0,
    marginLeft: 20,
    width: "100%",
    textTransform: "none",
    fontSize: "14px",
    boxShadow: "none",
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  labelText: {
    color: "#4D4F5C",
    fontSize: "14px",
    lineHeight: "18px",
  },
  headingTitle: {
    fontSize: 18,
    fontWeight: "bold",
    marginBottom: 20,
  },
  menuTitle: {
    marginLeft: 30,
    color: "#fff",
    cursor: "pointer",
    fontSize: 14,
    "&:hover": {
      textDecoration: "none",
    },
  },
  locationTitle: {
    float: "left",
    color: "#232323",
    fontSize: 14,
  },
  locationTitle2: {
    float: "left",
    color: "#232323",
    fontSize: 13,
    fontWeight: "bold",
  },
  rootPop: {
    display: "flex",
    alignItems: "center",
    borderRadius: 0,
    height: 30,
    marginTop: 10,
    marginBottom: 10,
  },
  inputPop: {
    marginLeft: theme.spacing(1),
    flex: 1,
  },
  iconButtonPop: {
    padding: 1,
    borderRadius: 0,
    backgroundColor: "#981B1E",
    height: 14,
    width: 16,
    color: "white",
  },
  divider: {
    height: 28,
    margin: 4,
  },
  textField: {
    backgroundColor: "green",
    borderRadius: "0.35rem",
  },
  radioLocationTitle: {
    color: "#303030",
    fontSize: 13,
  },
  noUserIcon: {
    fontSize: 35,
    color: "#40C9FC",
    width: "100%",
  },
  noUserTitle: {
    fontSize: 14,
  },
  message: {
    border: "1px solid #4AD991",
    padding: "10px",
    margin: "10px 0",
  },
  messageText: {
    color: "#4AD991",
  },
}));
